import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DocumentPreview } from './document-preview.model';

export const LINKED_DOCUMENT_PREVIEW_SCHEMA = Object.freeze({
  DATE_ADDED: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ),
  DOCUMENT: null, // DocumentPreview
});
export const RECORD = generateSchema(LINKED_DOCUMENT_PREVIEW_SCHEMA);
export const KEYS: any = generateKeys(LINKED_DOCUMENT_PREVIEW_SCHEMA);

export class LinkedDocumentPreview extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.DOCUMENT,
        value: props.get(KEYS.DOCUMENT)
          ? new DocumentPreview(this.documentPreview)
          : null,
      },
    ]) as LinkedDocumentPreview;
  }

  get dateAdded(): string {
    return this.get(KEYS.DATE_ADDED);
  }

  get documentPreview(): DocumentPreview {
    return this.get(KEYS.DOCUMENT);
  }
}
